module.exports = __webpack_public_path__ + "static/img/qd23.520b6ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/qualificationDoc/qd23.jpg
// module id = npYx
// module chunks = 1